/* Reference numbers remain readable; same-page citation jumps are intentionally disabled. */
(function () {
  'use strict';
  function isReference(link) {
    return link && link.matches('a[href^="#"]') && (link.closest('sup') || link.querySelector('sup') || link.classList.contains('facts-claim-ref'));
  }
  function unlink(link) {
    if (!isReference(link) || link.hasAttribute('data-clarity-claim')) return;
    var marker = document.createElement('span');
    if (link.className) marker.className = link.className;
    if (link.hasAttribute('style')) marker.setAttribute('style', link.getAttribute('style'));
    while (link.firstChild) marker.appendChild(link.firstChild);
    link.replaceWith(marker);
  }
  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.nodeType === 1) unlink(root);
    root.querySelectorAll('a[href^="#"]').forEach(unlink);
  }
  scan(document);
  // Rich text and translated FAQ content can be inserted after initial rendering.
  var main = document.querySelector('main');
  if (main) new MutationObserver(function (records) {
    records.forEach(function (record) { record.addedNodes.forEach(scan); });
  }).observe(main, {childList: true, subtree: true});
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();

